import { useEffect, useRef } from 'react';

/** A new response is a deliberate action, never an implicit historical rewrite. */
export function ConversationRestartNotice({ onRestart, pending = false, error }: {
  onRestart: () => void;
  pending?: boolean;
  error?: string | null;
}) {
  const heading = useRef<HTMLHeadingElement>(null);
  useEffect(() => { heading.current?.focus(); }, []);
  return <section className="w-full max-w-xl space-y-4 p-6 text-left" aria-labelledby="restart-conversation-title">
    <h1 ref={heading} tabIndex={-1} id="restart-conversation-title" className="text-2xl font-semibold focus:outline-none">Start a new conversation?</h1>
    <p className="text-muted-foreground">Your earlier answers will stay unchanged.</p>
    <div role="alert" className="text-sm text-danger">{error}</div>
    <button type="button" disabled={pending} onClick={onRestart}
      className="rounded-lg button-accent px-4 py-3 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed">Start new</button>
  </section>;
}
